import { chain, get, isEqual } from 'lodash';
import Wix from './wix-sdk-polyfill';
import { isSite } from './wix-sdk-utils';
import { isOfflinePostPageMigrationEnabled } from '@wix/communities-blog-client-common/dist/src/selectors/experiments-selectors';
import { updateAppSettings, updateAppSettingsOnStore } from '../actions/update-app-settings';
import { AUTOPILOT_USER_UUID } from '@wix/communities-blog-client-common/dist/src/constants/users';

const EXCLUDED_CSS_FONTS = /fonts\.googleapis/;

const isPresetsEqual = ({ textPresets, colorPresets }, state) =>
  isEqual(colorPresets, get(state, 'appSettings.colorPresets')) &&
  isEqual(textPresets, get(state, 'appSettings.textPresets'));

export default function listenToSettingsChange(store) {
  // TODO: remove when site colors are returned from app settings endpoint
  setTimeout(() => {
    const styleSettings = getStyleSettings();
    if (!isPresetsEqual(styleSettings, store.getState())) {
      store.dispatch(updateAppSettingsOnStore(styleSettings));
    }
  });

  if (isSite()) {
    return;
  }

  if (
    isOfflinePostPageMigrationEnabled(store.getState()) &&
    Wix.Utils.getInstanceValue('siteMemberId') === AUTOPILOT_USER_UUID
  ) {
    return;
  }

  Wix.addEventListener(Wix.Events.SITE_SAVED, () => {
    Wix.Styles.getStyleParams(style => {
      store.dispatch(updateAppSettings(Wix.Utils.getCompId(), 'draft', 'editor', getStyleSettings(style)));
    });
  });

  Wix.addEventListener(Wix.Events.SITE_PUBLISHED, () => {
    Wix.Styles.getStyleParams(style => {
      Wix.getExternalId(externalId => {
        store.dispatch(
          updateAppSettings(Wix.Utils.getCompId(), externalId || 'published', 'editor', getStyleSettings(style)),
        );
      });
    });
  });

  Wix.addEventListener(Wix.Events.STYLE_PARAMS_CHANGE, style => {
    store.dispatch(updateAppSettingsOnStore(getStyleSettings(style)));
  });

  Wix.addEventListener(Wix.Events.SETTINGS_UPDATED, data => store.dispatch(data));
}

function getStyleSettings(style = {}) {
  return {
    style: {
      ...style,
      cssUrls: getFontCssUrls(),
    },
    textPresets: Wix.Styles.getSiteTextPresets() || {},
    colorPresets: Wix.Styles.getSiteColors() || [],
  };
}

function getFontCssUrls() {
  return chain(document.styleSheets)
    .filter(styleSheet => styleSheet.href)
    .map(styleSheet => styleSheet.href.toLowerCase())
    .map(href => href.replace(/^https?:/, ''))
    .filter(href => !EXCLUDED_CSS_FONTS.test(href))
    .filter(href => href.indexOf('font') >= 0)
    .uniq()
    .value();
}
